// Contact greetings are computed centrally by Online-DB, never inferred from gender here.
export const buildOfferSalutation = (contact, language, legacySalutation = null) => {
  if (legacySalutation) {
    return /[,;.!?]$/.test(legacySalutation) ? legacySalutation : `${legacySalutation},`;
  }
  if (!["de", "en"].includes(language)) {
    throw new Error(`Unsupported offer language: ${language}`);
  }
  const field = language === "de" ? "germanGreeting" : "englishGreeting";
  if (!contact || typeof contact[field] !== "string" || !contact[field].trim()) {
    throw new Error(`Missing contact.${field} in offer response`);
  }
  return contact[field];
};
